const DibbleConfigs = {
    apiEndpoint: process.env.VUE_APP_API_URL,
};

export default DibbleConfigs;
